/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const FORGET_PASSWORD_SUCCESS = 'FORGET_PASSWORD_SUCCESS';
export const FORGET_PASSWORD_FAILED = 'FORGET_PASSWORD_FAILED';

export const ALERT_SUCCESS = 'ALERT_SUCCESS';
export const ALERT_ERROR = 'ALERT_ERROR';
export const ALERT_CLEAR = 'ALERT_CLEAR';

export const SPORTS_LIST = 'SPORTS_LIST';
export const SPORTS_LIST_SUCCESS = 'SPORTS_LIST_SUCCESS';
export const SPORTS_LIST_FAILED = 'SPORTS_LIST_FAILED';

export const LEAGUE_LIST = 'LEAGUE_LIST';
export const LEAGUE_LIST_SUCCESS = 'LEAGUE_LIST_SUCCESS';
export const LEAGUE_LIST_FAILED = 'LEAGUE_LIST_FAILED';

export const ADD_TO_BETSLIP = 'ADD_TO_BETSLIP';
export const REMOVE_FROM_BETSLIP = 'REMOVE_FROM_BETSLIP';
export const CLEAR_BETSLIP = 'CLEAR_BETSLIP';
export const UPDATE_TO_BETSLIP = 'UPDATE_TO_BETSLIP';
export const UPDATE_TO_PARLAY_BETSLIP = 'UPDATE_TO_PARLAY_BETSLIP';
export const LOAD_BETSLIP = 'LOAD_BETSLIP';
export const HIDE_BETSLIP_LOADER = 'HIDE_BETSLIP_LOADER';

export const REFRESH_USER_PROFILE_SUMMARY = 'REFRESH_USER_PROFILE_SUMMARY';

export const FANTACY_LOGIN = 'FANTACY_LOGIN';
export const FANTACY_LOGIN_REDIRECT = 'FANTACY_LOGIN_REDIRECT';
